module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobilearticleblock"
  }, [(this.infoline) ? _c('div', {
    staticClass: "mobilearticleflexcontainer"
  }, [_c('div', {
    staticClass: "mobilearticletext"
  }, [_vm._v("\n      " + _vm._s(_vm.art.title) + ", " + _vm._s(_vm.art.journal) + " " + _vm._s(_vm.art.volume)), (_vm.art.issue) ? _c('span', [_vm._v("(" + _vm._s(_vm.art.issue) + ")")]) : _vm._e(), _vm._v(":" + _vm._s(_vm.art.firstpage) + "-" + _vm._s(_vm.art.lastpage)), (_vm.art.coauthor) ? _c('span', [_vm._v(" (with " + _vm._s(_vm.art.coauthor) + ")")]) : _vm._e(), _vm._v(" (" + _vm._s(_vm.art.year) + ").\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mobilearticleiconbuttons"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.abs()
      }
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/file-text.svg")
    }
  })]), _vm._v(" "), (_vm.art.publink) ? _c('a', {
    attrs: {
      "href": _vm.art.publink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/external-link.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.art.altlink) ? _c('a', {
    attrs: {
      "href": _vm.art.altlink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/cloud-download.svg")
    }
  })]) : _vm._e()])]) : _c('div', [_c('hr'), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.art.title))]), _vm._v(" "), _c('h6', [_vm._v("Abstract")]), _vm._v(" "), (_vm.art.abstract) ? _c('p', [_vm._v(_vm._s(_vm.art.abstract))]) : _c('p', [_vm._v("Sorry, I don't have an abstract for this publication.")]), _vm._v(" "), _c('p', [(_vm.art.publink) ? _c('a', {
    attrs: {
      "href": _vm.art.publink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/external-link.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.art.altlink) ? _c('a', {
    attrs: {
      "href": _vm.art.altlink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/cloud-download.svg")
    }
  })]) : _vm._e()]), _c('br'), _vm._v(" "), _c('h6', [_vm._v("Citation")]), _vm._v(" "), _c('p', [_c('newcitation', {
    attrs: {
      "art": _vm.art
    }
  })], 1), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.line()
      }
    }
  }, [_vm._v("\nClose abstract.\n")])]), _vm._v(" "), _c('hr')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e45970e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pubs/mobilearticlerow.vue
// module id = 209
// module chunks = 0